import { GridHumanInsight } from './grid.hi.component';
import { SuperGroupHumanInsight } from './super-group.hi.component';

export default {
    'cmps-human-insight-super-group': SuperGroupHumanInsight,
    'cmps-human-insight-grid': GridHumanInsight,
};
